module.exports = __webpack_public_path__ + "static/media/helr65w_2.00b067ad.woff";